const TOKEN_KEY = 'squads_session_token';
const SESSION_KEY = 'squads_session';

export interface StoredSession {
  userId: string;
  username?: string;
}

export const storeToken = (token: string): void => {
  sessionStorage.setItem(TOKEN_KEY, token);
};

export const getStoredToken = (): string | null => {
  return sessionStorage.getItem(TOKEN_KEY);
};

export const clearToken = (): void => {
  sessionStorage.removeItem(TOKEN_KEY);
};

export const storeSession = (session: StoredSession): void => {
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
};

export const getStoredSession = (): StoredSession | null => {
  const raw = sessionStorage.getItem(SESSION_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as StoredSession;
  } catch {
    return null;
  }
};

export const clearSession = (): void => {
  sessionStorage.removeItem(SESSION_KEY);
};
